import { DataLayer } from "@sazka/utils/data-layer";
import { AnalyticsProduct } from "./analytics-product";

export class AnalyticsCart {
    products: Array<AnalyticsProduct>;

    constructor() {
        this.products = new Array<AnalyticsProduct>();
    }

    public addProduct(product: AnalyticsProduct) {
        this.products.push(product);
    }

    public empty() {
        this.products = new Array<AnalyticsProduct>();
    }

    public static pushEmptyCart() {
        DataLayer.push({ cart: { products: null } });
    }
}
